import { createFileRoute, redirect } from '@tanstack/react-router';
import NoOrganizationPage from '../../pages/NoOrganizationPage';

export const Route = createFileRoute('/_authenticated/no-organization')({
  beforeLoad: ({ context: { rhino } }) => {
    // Anyone with a membership has an organization to be in, so this page is
    // only ever the destination for an account that has none.
    if (rhino.usersRoles.length > 0) throw redirect({ to: '/' });
  },
  component: RouteComponent
});

function RouteComponent() {
  return <NoOrganizationPage />;
}
